import { Injectable } from '@angular/core';
import { environment} from '../../environments/environment';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Observable } from 'rxjs';
import { map} from 'rxjs/operators';
import { Router } from '@angular/router';
import { IStates } from '../model/states';
import { MessageService } from './message.service';


@Injectable({
  providedIn: 'root'
})
export class StatesService {

  // private token;
  constructor(private http: HttpClient, private router: Router, private msgSer: MessageService) {
  }

  getStatesData(): Observable<IStates> {
    return this.http.get(`${environment.apiUrl}states/all-states/` )
       .pipe(map((res: any) => {
         return res.data;
       }));

  }

  //
  // Get States
  //
  getAllStates( page, per_page, sorting, filtering): Observable<any> {
    let add_url = '';
    if (filtering.state !== '') {
      add_url = add_url + '&state=' + filtering.state;
    }

    return this.http.get(`${environment.apiUrl}states/states/` + '?page=' + page
                    + '&per_page=' + per_page + '&sort_by=' + sorting.value + '&sort_type='
                    + sorting.sort + add_url )
       .pipe(map(res => { return res; }));
  }

  //
  // Creates a new States record
  //
  createStates( form ) {

    return this.http.post(`${environment.apiUrl}states/`, form)
      .pipe(
        map((res: any) => {
          if (res.status) {
            return res;
          }
        })
      );
  }

  //
  // Update a States record
  //
  saveStates( id, form ) {
    return this.http.post(`${environment.apiUrl}states/` + id, form
    )
    .pipe(
      map((res: any) => {
        if (res.status) {
          return res.status;
        }
      })
    );
  }

  //
  // Retrieve States with given id
  //
  getStates( id ): Observable <IStates> {
    return this.http.get(`${environment.apiUrl}states/` + id)
        .pipe(
           map((res: any) => {
             if (res.status) {
               return res.data;
             }
           })
        );
  }


  //
  // Delete a new States record
  //
  deleteStates( id ): Observable <any> {

    return this.http.delete(`${environment.apiUrl}states/` + id)
      .pipe(
        map((res: any) => {
          if (res.status) {
            return res;
          }
        })
      );
  }

}
